
import {map} from 'rxjs/operators';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { DictionaryResponse } from './types/dictionary-response.type';
import { OeAppPersonService } from '../oe-app-person.service';
import { OeAppService } from '../oe-app.service';

@Injectable()
export class SearchWordService {

    constructor(private http: HttpClient, private oeAppPersonService: OeAppPersonService, private oeAppService: OeAppService) {
    }

    searchWord(word: string): Observable<DictionaryResponse> {
        const params = new HttpParams().set('word', word);
        return this.http.get<DictionaryResponse>(`${this.oeAppService.thirdPartyServiceHost}/v1/dictionary/definitions`, { params });
    }

    searchTranslation(word: string) {
        const person = this.oeAppPersonService.getPersonData();
        if (!person) { throw new Error('person not found'); }
        const { preferredLang } = person;

        if (!preferredLang) { throw new Error('preferred language not found'); }

        const params = new HttpParams().set('word', word).set('toLanguageCode', preferredLang);
        return this.http.get(`${this.oeAppService.thirdPartyServiceHost}/v1/dictionary/translations`, { params });
    }

    searchMatch(word: string) {
        const params = new HttpParams().set('word', word);
        return this.http.get(`${this.oeAppService.thirdPartyServiceHost}/v1/dictionary/matches`, { params }).pipe(
        map((result: any) => {
            let { results } = result;
            if (results && results.length) {
                results = results.filter((r) => r.region === 'us');
                result.results = results;
            }
            return result;
        }));
    }

    isTranslationAvailable() {
        const availableLanguages = ['es', 'pt'];

        const person = this.oeAppPersonService.getPersonData();
        if (!person) { return false; }
        const { preferredLang } = person;

        if (availableLanguages.includes(preferredLang)) {
            return true;
        }
        return false;
    }

}



// WEBPACK FOOTER //
// ./ts/app/shared/dictionary/search-word.service.ts